import React from 'react';
import { useSelector } from 'react-redux';
import { SelectItemType } from '../components/ui/selects/DefaultSelect';
import { AppStore } from '../store/applicationState';
import { API_ROUTE_PATH } from '../utils/api_routes';
import { callApi } from '../utils/callApi';
import {ALL_GROUPS, ALL_PARTICIPANTS} from "../utils/consts";
import {useGroupReport} from "./useGroupReport";
import {HashTableActiveGroup, IsActiveObject} from "../components/Analytics/useCharts";

export const useAiGenerate = () => {
    const { Workspaces } = useSelector((store: AppStore) => store);
    const [isLoading, setIsLoading] = React.useState(false);
    const refLinkCvs = React.useRef<any>(null);
    const [selectedPackage, setSelectedPackage] = React.useState<SelectItemType | null>(null);
    const [selectedAssessment, setSelectedAssessment] = React.useState<SelectItemType | null>(null);
    const [selectedStartPeriod, setSelectedStartPeriod] = React.useState<Date>(null);
    const [selectedEndPeriod, setSelectedEndPeriod] = React.useState<Date>(null);
    const [isForever, setIsForever] = React.useState<boolean>(false);
    const [activeGroups, setActiveGroups] = React.useState<HashTableActiveGroup>({})
    const [activeOriginSource, setActiveOriginSource] = React.useState<IsActiveObject[]>([])
    // const [activeCyclesLinks, setActiveCyclesLinks] = React.useState<SelectItemType[]>([]);
    const [selectOriginSource, setSelectOriginSource] = React.useState<SelectItemType[]>([ALL_PARTICIPANTS]);
    const [selectedOriginSource, setSelectedOriginSource] = React.useState<SelectItemType[] | null>([ALL_PARTICIPANTS]);

    const {
        selectedCycle,
        setSelectedCycle,
    } = useGroupReport();

    const getGroupIds = (groups: HashTableActiveGroup, isAllParticipants: boolean): string[] => {
        let groupsIdArr: string[] = []
        if (isAllParticipants) {
            return groupsIdArr
        }
        for (const key in groups) {
            if (groups.hasOwnProperty(key)) {
                if (groups[key][0].is_active) {
                    groups[key].forEach((itm) => {
                        itm.id !== ALL_GROUPS.id && groupsIdArr.push(itm.id)
                    })
                } else {
                    groups[key].forEach((itm) => {
                        itm.id !== ALL_GROUPS.id && itm.is_active && groupsIdArr.push(itm.id)
                    })
                }
            }
        }

        return groupsIdArr
    }

    // eslint-disable-next-line
    const getGroupNames = (groups: HashTableActiveGroup, isAllParticipants: boolean): string => {
        if (isAllParticipants) {
            return '';
        }

        const groupTitles: string[] = [];

        for (const key in groups) {
            if (!groups.hasOwnProperty(key)) continue;

            const groupList = groups[key];
            const isGroupActive = groupList[0]?.is_active;

            groupList.forEach((itm) => {
                if (itm.id !== ALL_GROUPS.id && (isGroupActive ? true : itm.is_active)) {
                    groupTitles.push(itm.title);
                }
            });
        }

        return groupTitles.map(title => `_${title}`).join('');
    }

    const genXlsx = async () => {
        if (!Workspaces.current) return null;
        if (!selectedPackage) return null;
        if(!selectedCycle) return null;
        if(!activeGroups) return null;
        if(!activeOriginSource) return null;
        setIsLoading(true);

        try {
            const activeIds: string[] = [];

            Object.values(activeGroups).forEach(objectArray => {
                objectArray.forEach(obj => {
                    if (obj.is_active) {
                        activeIds.push(obj.id);
                    }
                });
            });

            const reqData = {
                workspace_id: Workspaces.current.id,
                package_id: selectedPackage.id,
                package_link: selectedCycle.value,
                assessment_id: selectedAssessment.id,
                is_all_participants: activeOriginSource[0].is_active,
                groups_id: getGroupIds(activeGroups, activeOriginSource[0].is_active),
            };
            const { workspace_id,package_id, package_link, assessment_id, is_all_participants, groups_id} = reqData;
            const resp = await callApi({
                method: 'post',
                path: API_ROUTE_PATH.openAi.generateAiXlsxReport(
                    workspace_id
                ),
                data: {
                    workspace_id: workspace_id,
                    package_id: package_id,
                    package_link: package_link,
                    assessment_id: assessment_id,
                    period_start: selectedStartPeriod,
                    period_end: selectedEndPeriod,
                    is_forever: isForever,
                    is_all_participants: is_all_participants,
                    groups_id: groups_id,
                },
                responseType: 'blob',
            });

            const allPcts = '_all_participants'

            const groupsNames = '_groups'

            // AI Report_Название пекеджа_Название ассесмента_Цикл
            let outputFilename = `AI_Report_${selectedPackage.title}_${selectedAssessment.title}_${selectedCycle.title}`;

            if (activeOriginSource[0].is_active) {
                outputFilename += allPcts + '.xlsx'
            } else {
                outputFilename += groupsNames + '.xlsx'
            }

            // If you want to download file automatically using link attribute.
            const url = URL.createObjectURL(resp);
            const linkDoc = document.createElement('a');
            linkDoc.href = url;
            linkDoc.setAttribute('download', outputFilename);
            document.body.appendChild(linkDoc);
            linkDoc.click();
        } catch (e) {
            console.log(e);
            alert(JSON.stringify(e));
        } finally {
            setIsLoading(false);
        }
    };

    return {
        activeOriginSource,
        setActiveOriginSource,
        activeGroups,
        setActiveGroups,
        refLinkCvs,
        isLoading,
        genXlsx,
        setSelectedStartPeriod,
        setSelectedEndPeriod,
        setIsForever,
        selectedPackage,
        selectedCycle,
        selectOriginSource,
        setSelectOriginSource,
        selectedOriginSource,
        setSelectedOriginSource,
        setSelectedAssessment,
        selectedAssessment,
        setSelectedPackage,
        setSelectedCycle,
    };
};
